<template>
  <div
    class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop"
  >
    <div class="m-grid__item m-grid__item--fluid">
      <div class="m-subheader m-custom-subheader">
        <div
          class="d-flex align-items-center m-auto"
          :class="breakpointLG ? 'max-w-3xl' : 'max-w-lg'"
        >
          <div class="mr-auto">
            <div class="m-subheader__title custom-header">
              {{ $t("message.uploadImageComponent.header.titleHeader") }}
            </div>
          </div>
        </div>
      </div>
      <fileUploadResumeTable />
    </div>
  </div>
</template>

<script>
import { state, mutations } from '@/components/fileUpload/hooks/filters'
import fileUploadResumeTable from "@/components/fileUpload/fileUploadResumeTable.vue";
import { useWindowResize } from "@sichern/ui-elements";

export default {
  components: {
    fileUploadResumeTable,
  },
  provide: { state, mutations },
  data() {
    return {
      windowResize: useWindowResize(this),
    };
  },
  computed: {
    breakpointLG: function() {
      return this.windowResize.width < 1024;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../public/assets/scss/_config.scss";

.m-subheader__title {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  color: $bluePrimary !important;
}

.headerSubtitleStyles1 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: $textPrimary;
}

.headerSubtitleStyles2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: $buttonPrimary;
}

.icon-RightChevron {
  padding: 0px !important;
}

.m-custom-subheader {
  padding-top: 0;
}
.custom-header {
  padding: 0;
  line-height: 1;
}

.max-w-lg {
  max-width: 1143px;
}
</style>
